import React from 'react';
import { Route } from 'react-router-dom';

import ClusterTypeGrid from './ClusterTypeGrid';
import ClusterTypeForm from './ClusterTypeForm';

/**
 * Contenedor de ClusterType. La RUTA decide qué se monta (no un flag isDetail):
 *  - /ClusterType            → lista (ClusterTypeGrid)
 *  - /ClusterType/:clusterId → formulario (ClusterTypeForm); 'undefined' = nuevo
 * El `key` fuerza re-montar el form al cambiar de id (p.ej. tras crear uno nuevo).
 */
export default function ClusterType(props) {
  const nivel = props.nivel;

  return (
    <>
      <Route exact path="/ClusterType"
        render={() => <ClusterTypeGrid nivel={nivel} />} />

      <Route path="/ClusterType/:clusterId"
        render={({ match }) => (
          <ClusterTypeForm
            key={match.params.clusterId}
            nivel={nivel}
            clusterId={match.params.clusterId}
          />
        )} />
    </>
  );
}
